/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import React from "react"

export class VideoErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: null as Error | null,
    info: undefined as undefined | Record<string, unknown>,
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error | null, info: any) {
    console.error(error, info)

    this.setState({ error, info })
  }

  onClearError() {
    this.setState({ hasError: false, error: null })
  }

  render() {
    const { hasError } = this.state
    return hasError ? (
      <div
        css={css`
          background: grey;
          color: white;
          text-align: center;
          padding: 100px 50px;

          span {
            display: block;
            margin-top: 32px;
            opacity: 0.5;
          }
        `}
      >
        An error occurred{""}
        <br />
        <span>
          {this.state?.error ? this.state.error?.message ?? JSON.stringify(this.state.error) : null}
        </span>
      </div>
    ) : (
      this.props.children
    )
  }
}
